<template>
  <el-card style="height: 600px" shadow="never">
    <div style="font-size: 14px; font-weight: bold; margin-bottom: 5px">
      水肥控制
    </div>
    <div v-if="irrigateSn == undefined" style="font-size: 12px; color: #999">
      该地块尚未安装或配置水肥设备
    </div>
     <iframe  v-else-if="irrigateSn == 1"
      :src="'http://web.v-box.net/web/html/Viewer.html?proid=19097'"
      style="width: 100%; height: 500px"
      frameborder="0"
      scrolling="auto"
    >
    </iframe>
    <iframe
      v-else
      :src="'http://app2.sinoverse.cn:9911/wlw/json/sfj?did=' + irrigateSn"
      style="width: 100%; height: 500px"
      frameborder="0"
      scrolling="auto"
    >
    </iframe>
  </el-card>
</template>
<script>
export default {
  props: ['irrigateSn'],
  data() {
    return {
      id: undefined,
    }
  },
  methods: {},
}
</script>



// WEBPACK FOOTER //
// src/components/monitor/environment/MonitorIrrigate.vue